import { Drawer, SwipeableDrawer, Box, Typography, Button, Stack, useMediaQuery, useTheme } from "@mui/material"
import RangeFilter from "./filters/RangeFilter"
import TripleEXFilter from "./filters/TripleEXFilter"
import MultiSelectFilter from "./filters/MultiSelectFilter"

function FiltersSheet({ open, onClose, modifiers, loading }) {
    const { actions } = modifiers
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

    const PaperProps = {
        sx: {
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            px: { xs: 2, sm: 3 },
            pt: { xs: 2, sm: 3 },
            pb: { xs: 2.5, sm: 4 },
            maxHeight: '90vh'
        }
    }

    if (isMobile) {
        return (
            <SwipeableDrawer
                anchor="bottom"
                open={open}
                onClose={onClose}
                onOpen={() => {}}
                disableSwipeToOpen
                PaperProps={PaperProps}
            >
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                    <Box sx={{ width: 40, height: 4, bgcolor: 'divider', borderRadius: 2 }} />
                </Box>
                
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 2.5 }}>
                    Filters
                </Typography>
                
                <Stack spacing={{ xs: 2.25, sm: 3 }} sx={{ overflowY: 'auto', mb: 3, pt: { xs: 0.75, sm: 0 } }}>
                    <RangeFilter selector="ct" modifiers={modifiers} loading={loading} />
                    
                    <Stack spacing={1.5}>
                        <MultiSelectFilter selector="color" modifiers={modifiers} align={isMobile ? "left" : "center"} />
                        <MultiSelectFilter selector="clarity" modifiers={modifiers} align={isMobile ? "left" : "center"} />
                    </Stack>

                    <Stack spacing={1.5}>
                        <TripleEXFilter modifiers={modifiers} align={isMobile ? "left" : "center"} />
                        <MultiSelectFilter selector="cut" modifiers={modifiers} align={isMobile ? "left" : "center"} />
                        <MultiSelectFilter selector="polish" modifiers={modifiers} align={isMobile ? "left" : "center"} />
                        <MultiSelectFilter selector="symm" modifiers={modifiers} align={isMobile ? "left" : "center"} />
                    </Stack>
                </Stack>

                <Box sx={{ display: 'flex', flexDirection: { xs: 'row', sm: 'column' }, gap: 1.5, mt: 'auto' }}>
                    <Button 
                        variant="contained" 
                        color="primary" 
                        fullWidth={!isMobile}
                        size={isMobile ? "medium" : "large"}
                        onClick={onClose}
                        sx={{ borderRadius: 2, py: isMobile ? 1 : 1.5, fontWeight: 700, flex: 1, order: { xs: 2, sm: 1 } }}
                    >
                        OKAY
                    </Button>
                    <Button 
                        variant="outlined" 
                        color="inherit" 
                        fullWidth={!isMobile}
                        size={isMobile ? "medium" : "large"}
                        onClick={() => {
                            actions.reset()
                            onClose()
                        }}
                        sx={{ borderRadius: 2, py: isMobile ? 1 : 1.5, borderColor: 'divider', fontWeight: 600, flex: 1, order: { xs: 1, sm: 2 } }}
                    >
                        RESET
                    </Button>
                </Box>
            </SwipeableDrawer>
        )
    }

    return (
        <Drawer
            anchor="bottom"
            open={open}
            onClose={onClose}
            PaperProps={PaperProps}
        >
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                <Box sx={{ width: 40, height: 4, bgcolor: 'divider', borderRadius: 2 }} />
            </Box>
            
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2.5 }}>
                Filters
            </Typography>
            
            <Stack spacing={{ xs: 2.25, sm: 3 }} sx={{ overflowY: 'auto', mb: 3, pt: { xs: 0.75, sm: 0 } }}>
                <RangeFilter selector="ct" modifiers={modifiers} loading={loading} />
                
                <Stack spacing={1.5}>
                    <MultiSelectFilter selector="color" modifiers={modifiers} align={isMobile ? "left" : "center"} />
                    <MultiSelectFilter selector="clarity" modifiers={modifiers} align={isMobile ? "left" : "center"} />
                </Stack>

                <Stack spacing={1.5}>
                    <TripleEXFilter modifiers={modifiers} align={isMobile ? "left" : "center"} />
                    <MultiSelectFilter selector="cut" modifiers={modifiers} align={isMobile ? "left" : "center"} />
                    <MultiSelectFilter selector="polish" modifiers={modifiers} align={isMobile ? "left" : "center"} />
                    <MultiSelectFilter selector="symm" modifiers={modifiers} align={isMobile ? "left" : "center"} />
                </Stack>
            </Stack>

            <Box sx={{ display: 'flex', flexDirection: { xs: 'row', sm: 'column' }, gap: 1.5, mt: 'auto' }}>
                <Button 
                    variant="contained" 
                    color="primary" 
                    fullWidth={!isMobile}
                    size={isMobile ? "medium" : "large"}
                    onClick={onClose}
                    sx={{ borderRadius: 2, py: isMobile ? 1 : 1.5, fontWeight: 700, flex: 1, order: { xs: 2, sm: 1 } }}
                >
                    OKAY
                </Button>
                <Button 
                    variant="outlined" 
                    color="inherit" 
                    fullWidth={!isMobile}
                    size={isMobile ? "medium" : "large"}
                    onClick={() => {
                        actions.reset()
                        onClose()
                    }}
                    sx={{ borderRadius: 2, py: isMobile ? 1 : 1.5, borderColor: 'divider', fontWeight: 600, flex: 1, order: { xs: 1, sm: 2 } }}
                >
                    RESET
                </Button>
            </Box>
        </Drawer>
    )
}

export default FiltersSheet
